export { default } from './RecentlyReturnedStatus';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedStatus/index.js